<template>
  <div class="index">
    <!-- <Header title=" 手机盾证书" :back="true" left="首页" :white="true" ref="headerheight" /> -->
    <div class="indexmain">
      <van-sticky :offset-top=headerheight ref="bannerheight">
        <div class="banner">
          <img src="@/assets/image/del/shild.png" alt />
        </div>
      </van-sticky>

      <div class="main">
        <van-tabs title-active-color="#000" color="#000" scrollspy sticky :offset-top=tabHeight>
          <van-tab title="功能介绍">
            <div class="yw">
              <div class="title">
                <img src="@/assets/image/icon19.png" style="margin-right:8px" alt="">
                <span>功能介绍</span>
                <img src="@/assets/image/icon19.png" style="margin-left:8px" alt="">
              </div>
              <div class="pro">
                <p class="tips_tow">申请单一窗口手机盾有什么作用？</p>
                <p class="tips_last spa">“掌上单一窗口”APP为企业操作员和部门管理员或部门操作员提供手机盾注册登录、加签功能。</p>
                <p class="tips_last spa">1、“掌上单一窗口”APP企业手机盾用户注册登录后，用户操作权限等同中国国际贸易单一窗口PC端IC卡插卡登录用户权限；</p>
                <p class="tips_last spa">2、企业手机盾“加签”功能：在查询、办理、申报等数据安全性要求较高的单一窗口业务时，需要输入手机盾密码进行加签。</p>
                <p class="tips_last spa">3、“掌上单一窗口”APP部门手机盾用户注册登录后，完成身份认证。</p>
              </div>
              <div class="pro">
                <p class="tips_tow">单一窗口手机盾的使用者是谁？</p>
                <p class="tips_last spa">需要办理相关单一窗口业务的企业操作员，在“掌上单一窗口”APP申请手机盾证书并登录后，就可以办理需要在PC端插卡登录才能使用的单一窗口业务。企业法人不能申请、使用手机盾功能。</p>
                <p class="tips_last spa">需要完成身份认证的部门管理员或部门操作员，在“掌上单一窗口”APP申请手机盾证书并登录后，通过扫码登录应用系统。</p>
              </div>
            </div>

          </van-tab>
          <van-tab title="申请流程">
            <div class="yw">
              <div class="title">
                <img src="@/assets/image/icon19.png" style="margin-right:8px" alt="">
                <span>申请流程</span>
                <img src="@/assets/image/icon19.png" style="margin-left:8px" alt="">
              </div>
              <div class="pro">
                <p class="tips_tow">已有企业操作员账号，如何申请？</p>
                <p class="tips_last spa">如果已有在中国电子口岸执法系统“身份认证管理”子系统备案的企业操作员账号（包括中国国际贸易单一窗口的操作员用户)，可以直接登录“掌上单一窗口”APP申请手机盾证书。</p>
              </div>
              <div class="pro">
                <p class="tips_tow">没有企业操作员账号，如何申请？</p>
                <p class="tips_last spa">1、首先需要申请企业操作员备案：</p>
                <p class="tips_last spa">操作员信息需要在中国电子口岸执法系统“身份认证管理”子系统备案后才能申请手机盾证书；</p>
                <p class="tips_last spa">2、创建操作员用户：</p>
                <p class="tips_last spa">操作员备案通过后，使用法人卡登录“中国国际贸易单一窗口”点击右上角的用户名，进入到用户管理，创建上一步备案过的操作员用户；</p>
                <p class="tips_last spa">3、操作员激活：</p>
                <p class="tips_last spa">使用上一步创建的操作员，登录“中国国际贸易单一窗口”进行用户激活。</p>
              </div>
              <div class="pro">
                <p class="tips_tow">没有企业操作员账号，但曾插卡登录过PC端，如何申请？</p>
                <p class="tips_last spa">如果企业操作员未申请过账号，仅插卡登录过中国国际贸易单一窗口PC端：</p>
                <p class="tips_last spa">1、当企业用操作员卡登录PC端后，系统会自动为这个企业创建一个操作员账号。操作员账号的用户名为卡号。系统自动创建的操作员账号是未激活状态，如果想用该用户名和密码登录“掌上单一窗口”APP，需要先激活。</p>
                <p class="tips_last spa">2、之后使用操作员用户名、密码登录“掌上单一窗口”进行手机盾证书的申请。</p>

              </div>
              <div class="pro">
                <p class="tips_tow">如何在APP申请手机盾证书？</p>
                <p class="tips_last spa">1、使用企业操作员、部门管理员或部门操作员账号登录“掌上单一窗口”APP后，进入“我的->账号与安全->手机盾证书管理”，点击手机盾证书管理；</p>
                <p class="tips_last spa">2、进入申请界面，确认界面信息无误后，根据界面提示持对应的操作员IC卡或法人IC卡到“单一窗口”PC端对手机盾证书申请进行确认；</p>
                <p class="tips_last spa">3、确认通过后，设置手机盾密码（密码的复杂度校验：长度6位，支持数字、大小写字母、特殊字符，单项或任意组合均可），完成证书申请。</p>

              </div>
            </div>

          </van-tab>
          <van-tab title="加签功能">
            <div class="yw" style="padding-bottom:250px">
              <div class="title">
                <img src="@/assets/image/icon19.png" style="margin-right:8px" alt="">
                <span>加签功能</span>
                <img src="@/assets/image/icon19.png" style="margin-left:8px" alt="">
              </div>
              <div class="pro">
                <p class="tips_tow">手机盾加签如何使用？</p>
                <p class="tips_last spa">使用手机盾登录，在“掌上单一窗口”APP进行申报类业务办理时，点击申报。若该功能需要进行加签，则提示加签，输入手机盾的密码，加签成功，提交申报请求。</p>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>

      <!-- <div class="foot">
        <div class="check">
          <van-checkbox v-model="checked" shape="square" icon-size="15"></van-checkbox>
          <p style="margin-left:10px">记住我的选择，下次不再提示</p>
        </div>
        <div class="btn">
          <button class="btn1" color="#F8F8F8" @click="submit(502)">退出</button>
          <button class="btn2" color="#F8F8F8" @click="submit(704)">去申请</button>
        </div>
      </div> -->

    </div>
  </div>
</template>

<script>
import {
  Sticky,
  Grid,
  GridItem,
  Field,
  Tab,
  Tabs,
  Checkbox,
  CheckboxGroup,
} from "vant";
export default {
  name: "topicDetail",
  /**
   * 初始化数据
   */
  data() {
    return {
      statusBar: 0,
      accountType: "",
      active: 0,
      checked: true,
      headerheight: 0,
      tabHeight: 0,
    };
  },
  /**
   * 初始化
   */
  mounted() {
    this.statusBar = this.$tool.statusBar(45);
    // this.headerheight = this.$refs.headerheight.$el.offsetHeight + 0.3;
    this.tabHeight =
      this.$refs.bannerheight.$el.offsetHeight +
      // this.$refs.headerheight.$el.offsetHeight +
      0.3;
    console.log(this.$refs.bannerheight.$el.offsetHeight);
    console.log(this.headerheight);
    console.log(this.tabHeight);
  },
  /**
   * 方法
   */
  methods: {
    goto() {
      console.log("test");
    },
    /**
     * 跳转小应用
     */
  },
  components: {
    [Sticky.name]: Sticky,
    [GridItem.name]: GridItem,
    [Grid.name]: Grid,
    [Field.name]: Field,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
  },
};
</script>

<style scoped lang="scss">
.index {
  background: #f3f3f3;

  .indexmain {
    overflow: hidden;
    .banner {
      background: #f3f3f3;
      padding: 12px 15px;
      overflow: hidden;
      img {
        width: 345px;
        height: 103px;
      }
    }
    .yw {
      margin-top: 18px;
      .title {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 12px;
        img {
          width: 7.6px;
          height: 12px;
        }
        span {
          font-size: 16px;
          font-weight: bold;
          font-family: PingFangSC-Medium;
          line-height: 22px;
        }
      }
      .pro {
        margin: 0px 15px;
        margin-bottom: 10px;
        padding: 15px;
        background: white;
        width: 315px;
        // height: 100px;
        .tips_tow {
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: PingFangSC-Medium;
          line-height: 22.5px;
          font-size: 16px;
          //   font-weight: bold;
          color: #095495;
          padding-bottom: 7px;
        }
        .tips_last {
          font-size: 14px;
          line-height: 20px;
          padding-bottom: 7px;
          color: #031e36;
          letter-spacing: 0;
        }
        .spa {
          text-indent: 25px;
        }
      }
    }

    .check {
      display: flex;
      justify-content: center;
      //   align-items: center;
      padding-top: 22px;
    }
  }
  .main {
    // height: 300px;
    overflow: hidden;
  }
  .foot {
    background: #f3f3f3;
    position: fixed;
    bottom: 0px;
    width: 100%;
    overflow: hidden;
  }
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 22px;
    .btn1 {
      background: #f8f8f8;
      border: 1px solid;
      border-radius: 5px;
      width: 100px;
      height: 40px;
      font-size: 17px;
      color: $fontColor;
    }
    .btn2 {
      background: $themColor2;
      border: 1px solid;
      border-radius: 5px;
      width: 100px;
      height: 40px;
      color: #fff;
      font-size: 17px;
      margin-left: 30px;
    }
  }
}
</style>

